<template>
  <div class="col-lg-9 col-md-12 p-0 border m-auto" ref="container">
    <canvas :width="width" :height="height" ref="canvas"></canvas>
  </div>
</template>
<script>
import Konva from 'konva'

export default {
  name: 'SignDrawCanvas',
  props: {
    'allowDrawing': Object,
    'drawMode': String,
    'penColor': String
  },
  data: () => ({
    width: 200,
    height: 200,
    stage: null,
    canvas: null,
    context: null,
    drawingLayer: null,
    drawingScope: null,
    lastPointerPosition: {},
    localPos: {
      x: 0,
      y: 0
    },
    pos: null
  }),
  watch: {
    penColor: function () {
      // 文字色変更時
      this.context.strokeStyle = this.penColor
    },
    allowDrawing: function (newBoolean, oldBoolean) {
      this.allowDrawing = newBoolean
      if (this.allowDrawing.isOperationPossible) {
        this.drawingScope.on('mousedown', this.mousedown)
        this.stage.addEventListener('mouseup', this.mouseup)
        this.stage.addEventListener('mousemove', this.mousemove)
        this.drawingScope.on('touchstart', this.mousedown)
        this.stage.addEventListener('touchend', this.mouseup)
        this.stage.addEventListener('touchmove', this.mousemove)
      } else {
        this.drawingScope.off('mousedown', this.mousedown)
        this.stage.removeEventListener('mouseup', this.mouseup)
        this.stage.removeEventListener('mousemove', this.mousemove)
        this.drawingScope.off('touchstart', this.mousedown)
        this.stage.removeEventListener('touchend', this.mouseup)
        this.stage.removeEventListener('touchmove', this.mousemove)
      }
    }
  },
  mounted: function () {
    const computedStyle = window.getComputedStyle(document.getElementById('content-area-inner'))
    let baseWidth = document.getElementById('content-area-inner').clientWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight))
    baseWidth -= 2 // ボーダー2px分をマイナス
    this.width = window.innerWidth >= 992 ? (baseWidth / 12) * 9 : baseWidth
    window.addEventListener('resize', this.calculateWidth)

    var container = this.$refs.container
    this.stage = new Konva.Stage({
      container,
      width: this.width,
      height: this.height
    })
    this.drawingLayer = new Konva.Layer()
    this.stage.add(this.drawingLayer)

    this.canvas = this.$refs.canvas
    this.drawingScope = new Konva.Image({
      image: this.canvas,
      x: 0,
      y: 0,
      stroke: '',
      fill: '#FFF'
    })
    this.drawingLayer.add(this.drawingScope)
    this.stage.draw()

    this.context = this.canvas.getContext('2d')
    this.context.strokeStyle = '#000000'
    this.context.lineJoin = 'round'
  },
  methods: {
    mousedown: function () {
      this.isPaint = true
      // ペンモード時
      if (this.drawMode === 'pen') {
        this.context.lineWidth = this.consts.drawCanvasPenLineWidthPixel.sign
        this.context.globalCompositeOperation = 'source-over'
      }
      // 消しゴムモード時
      if (this.drawMode === 'eraser') {
        this.context.lineWidth = this.consts.drawCanvasEraserLineWidthPixel
        this.context.globalCompositeOperation = 'destination-out'
      }

      // マウスダウン時の座標を取得しておく
      this.lastPointerPosition = this.stage.getPointerPosition()
      this.$emit('sendSignalingDraw', this.stage.getPointerPosition(), true)
    },
    mouseup: function () {
      this.isPaint = false
    },
    mousemove: function () {
      if (!this.isPaint) {
        return
      }

      // 描画処理
      this.drawing(this.stage.getPointerPosition())

      // 座標をシグナリングで送信
      this.$emit('sendSignalingDraw', this.stage.getPointerPosition(), false)
    },
    syncDraw (signalingData) {
      if (signalingData['is_mousedown']) {
        // ペンモード時
        if (this.drawMode === 'pen') {
          this.context.lineWidth = this.consts.drawCanvasPenLineWidthPixel.sign
          this.context.globalCompositeOperation = 'source-over'
        }
        // 消しゴムモード時
        if (this.drawMode === 'eraser') {
          this.context.lineWidth = this.consts.drawCanvasEraserLineWidthPixel
          this.context.globalCompositeOperation = 'destination-out'
        }
        this.lastPointerPosition = signalingData['position']
      }
      // 描画処理
      this.drawing(signalingData['position'])
    },
    drawing (pointerPosition) {
      this.context.beginPath()
      this.localPos.x = this.lastPointerPosition.x - this.drawingScope.x()
      this.localPos.y = this.lastPointerPosition.y - this.drawingScope.y()

      // 描画開始座標を指定する
      this.context.moveTo(this.localPos.x, this.localPos.y)

      this.pos = pointerPosition
      this.localPos.x = this.pos.x - this.drawingScope.x()
      this.localPos.y = this.pos.y - this.drawingScope.y()

      // 描画開始座標から、lineToに指定された座標まで描画する
      this.context.lineTo(this.localPos.x, this.localPos.y)
      this.context.closePath()
      this.context.stroke()
      this.drawingLayer.draw()

      this.lastPointerPosition = this.pos
    },
    onClearCanvas: function () {
      this.context.globalCompositeOperation = 'destination-out'
      this.context.fillRect(0, 0, this.width, this.height)
      this.drawingLayer.draw()
    },
    onExportDrawnImage: function () {
      this.$emit('registDrawnImage', this.stage.toDataURL())
    },
    calculateWidth () {
      const computedStyle = window.getComputedStyle(document.getElementById('content-area-inner'))
      this.width = document.getElementById('content-area-inner').clientWidth - (parseFloat(computedStyle.paddingLeft) + parseFloat(computedStyle.paddingRight))
      this.width -= 2 // ボーダー2px分をマイナス
      window.innerWidth >= 992 ? this.stage.width((this.width / 12) * 9) : this.stage.width(this.width)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SignDrawCanvas.vue